<template>
  <section
      class="pte h-screen" ref="pte"
      :style="{'--bg-image': `url(${bgImageUrl})`}">
    <div class="h-1/10 w-full blex lg:hidden lg:mb-20 pt-0 lg:pt-90 justify-self-center">
      <div class="blex text-white font-bold text-2xl bottom-gradient lg:pb-12 whitespace-no-wrap">
        PLAY TO EARN
      </div>
    </div>
    <div class="h-9/10 lg:h-full w-full pt-0 lg:pt-100">
      <div class="w-full blex lg:justify-end h-full">
        <div class="blex w-full h-full">
          <!-- world image     -->
          <!--          <div class="w-full lg:w-7/10 pr-0 lg:pr-100">-->
          <div
              class="w-full h-2/7 lg:h-full lg:w-3/5 py-5 lg:py-0 pr-0 lg:pr-100 rot-images-wrapper blex">
            <svg class="block" width="85%" height="85%" viewBox="0 0 490 490" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <circle id="ptePath" cx="245" cy="245" r="244.5" fill="none" fill-opacity="0.44"
                      stroke="url(#paint0_linear_604_120)"/>
              <defs>
                <linearGradient id="paint0_linear_604_120" x1="490" y1="489.983" x2="0" y2="489.983"
                                gradientUnits="userSpaceOnUse">
                  <stop stop-color="white" stop-opacity="0"/>
                  <stop offset="0.536458" stop-color="white"/>
                  <stop offset="1" stop-color="white" stop-opacity="0"/>
                </linearGradient>
              </defs>
            </svg>
            <div class="blex lg:blex-right rot-images index-0">
              <!--    농업          -->
              <img
                  :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/playToEarn/agriculture.png') : require('@/assets/images/pages/main/playToEarn/mAgriculture.png')"
                  alt="" class="world">
            </div>
            <div class="blex lg:blex-right rot-images index-3">
              <!--    채광          -->
              <img
                  :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/playToEarn/mining.png') : require('@/assets/images/pages/main/playToEarn/mMining.png')"
                  alt="" class="world">
            </div>
            <div class="blex lg:blex-right rot-images index-2">
              <!--    낚시          -->
              <img :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/playToEarn/fishing.png') : require('@/assets/images/pages/main/playToEarn/mFishing.png')"
                   alt="" class="world">
            </div>
            <div class="blex lg:blex-right rot-images index-1">
              <!--    목장          -->
              <img :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/playToEarn/farm.png') : require('@/assets/images/pages/main/playToEarn/mFarm.png')"
                   alt="" class="world">
            </div>
          </div>

          <!-- description      -->
          <div
              class="blex h-5/7 lg:h-full items-start w-full px-16 lg:px-30 lg:w-2/5 descriptions">
            <div
                class="hidden lg:block text-center text-white font-bold lg:text-6xl bottom-gradient py-12">
              PLAY TO EARN
            </div>
            <div class="w-full relative overflow-hidden h-full">
              <div class="description">
                <!--   농업 세계관 설명        -->
                <div class="desc py-12 lg:pb-0">
                  <div class="text-base lg:text-4xl text-white font-semiBold">
                    {{ $t('playToEarn.0') }}
                  </div>
                  <div class="blex pl-12 pt-8 lg:pt-40">
                    <div class="text-white font-medium text-3xs lg:text-base pb-8 leading-2xs lg:leading-xs">
                      {{ $t('playToEarn.1') }}
                      {{ $t('playToEarn.2') }}
                      {{ $t('playToEarn.3') }}
                    </div>
                    <div class="text-white font-medium text-3xs lg:text-base pb-0 lg:pb-20 leading-2xs lg:leading-xs">
                      {{ $t('playToEarn.4') }}<br class="block lg:hidden">
                      {{ $t('playToEarn.5') }}
                      {{ $t('playToEarn.30') }}
                    </div>
                  </div>
                  <vs-divider color="dark" class="py-0"></vs-divider>
                  <div class="pb-8 lg:pb-40">
                    <div class="font-semiBold text-xs lg:text-lg text-white">
                      {{ $t('playToEarn.6') }}
                    </div>
                    <div class="pl-12">
                      <div class="py-8 text-white font-base text-3xs lg:text-xs leading-2xs lg:leading-xs">
                        {{ $t('playToEarn.7') }}<br>
                        {{ $t('playToEarn.8') }}
                      </div>
                      <div class="text-white font-base text-3xs lg:text-xs leading-2xs lg:leading-xs">
                        {{ $t('playToEarn.9') }}<br class="block lg:hidden">
                        {{ $t('playToEarn.10') }}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="font-semiBold text-xs lg:text-lg text-white">
                      {{ $t('playToEarn.11') }}
                    </div>
                    <div class="pl-12">
                      <div class="py-8 lg:py-12 text-light-gray font-base text-3xs lg:text-xs leading-2xs lg:leading-xs">
                        {{ $t('playToEarn.12') }}
                      </div>
                    </div>
                  </div>
                </div>

                <!--   목장 세계관 설명        -->
                <div class="desc absolute top-0 py-12 lg:pb-0">
                  <div class="text-base lg:text-4xl text-white font-semiBold">
                    {{ $t('playToEarn.13') }}
                  </div>
                  <div class="blex pl-12 pt-8 lg:pt-40">
                    <div class="text-white font-medium text-3xs lg:text-base pb-0 lg:pb-20 leading-2xs lg:leading-xs">
                      {{ $t('playToEarn.14') }}
                    </div>
                  </div>
                  <vs-divider color="dark" class="py-0"></vs-divider>
                  <div class="pb-8 lg:pb-40">
                    <div class="font-semiBold text-xs lg:text-lg text-white">
                      {{ $t('playToEarn.15') }}
                    </div>
                    <div class="pl-12">
                      <div class="pt-8 pb-0 lg:py-12 text-white font-base text-3xs lg:text-xs leading-2xs lg:leading-xs">
                        {{ $t('playToEarn.16') }}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="font-semiBold text-xs lg:text-lg text-white">
                      {{ $t('playToEarn.17') }}
                    </div>
                    <div class="pl-12">
                      <div class="py-8 lg:py-12 text-light-gray font-base text-3xs lg:text-xs leading-2xs lg:leading-xs">
                        {{ $t('playToEarn.18') }}
                      </div>
                    </div>
                  </div>
                </div>

                <!--   낚시 세계관 설명        -->
                <div class="desc absolute top-0 py-12 lg:pb-0">
                  <div class="text-base lg:text-4xl text-white font-semiBold">
                    {{ $t('playToEarn.19') }}
                  </div>
                  <div class="blex pl-12 pt-8 lg:pt-40">
                    <div class="text-white font-medium text-3xs lg:text-base pb-0 lg:pb-20 leading-2xs lg:leading-xs">
                      {{ $t('playToEarn.20') }}
                    </div>
                  </div>
                  <vs-divider color="dark" class="py-0"></vs-divider>
                  <div class="pb-0 lg:pb-20 lg:pb-40">
                    <div class="font-semiBold text-xs lg:text-lg text-white">
                      {{ $t('playToEarn.21') }}
                    </div>
                    <div class="pl-12">
                      <div class="py-8 lg:py-12 text-white font-base text-3xs lg:text-xs leading-2xs lg:leading-xs">
                        {{ $t('playToEarn.22') }}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="font-semiBold text-xs lg:text-lg text-white">
                      {{ $t('playToEarn.23') }}
                    </div>
                    <div class="pl-12">
                      <div class="py-8 lg:py-12 text-light-gray font-base text-3xs lg:text-xs leading-2xs lg:leading-xs">
                        {{ $t('playToEarn.24') }}
                      </div>
                    </div>
                  </div>
                </div>

                <!--   채광 세계관 설명        -->
                <div class="desc absolute top-0 py-12 lg:pb-0">
                  <div class="text-base lg:text-4xl text-white font-semiBold">
                    {{ $t('playToEarn.25') }}
                  </div>
                  <div class="blex pl-12 pt-8 lg:pt-40">
                    <div class="text-white font-medium text-3xs lg:text-base pb-8 leading-2xs lg:leading-xs">
                      {{ $t('playToEarn.26') }}
                    </div>
                    <div class="text-white font-medium text-3xs lg:text-base pb-0 lg:pb-20 leading-2xs lg:leading-xs">
                      {{ $t('playToEarn.27') }}
                    </div>
                  </div>
                  <vs-divider color="dark" class="py-0"></vs-divider>
                  <div>
                    <div class="font-semiBold text-xs lg:text-lg text-white">
                      {{ $t('playToEarn.28') }}
                    </div>
                    <div class="pl-12">
                      <div class="py-8 lg:py-12 text-light-gray font-base text-3xs lg:text-xs leading-2xs lg:leading-xs">
                        {{ $t('playToEarn.29') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  </section>
</template>

<script>
import {TweenMax, TimelineMax, TweenLite, Power4, Power1, Elastic} from 'gsap'
import {EventBus} from '../../EventBus'

let timeline = null
export default {
  name: 'PlayToEarn',
  data: () => ({
    bgImages: [
      require('@/assets/images/pages/main/playToEarn/agriculture.png'),
      require('@/assets/images/pages/main/playToEarn/farm.png'),
      require('@/assets/images/pages/main/playToEarn/fishing.png'),
      require('@/assets/images/pages/main/playToEarn/mining.png')
    ],
    bgImageIndex: 0
  }),
  computed: {
    bgImageUrl() {
      return this.bgImages[this.bgImageIndex]
    }
  },
  methods: {
    initPaths() {
      this.$motionPlugin.convertToPath('#ptePath')
      const timeline = this.$gsap.timeline({
        ease: Power1.easeInOut,
        scrollTrigger: {
          invalidateOnRefresh: true,
          scroller: '#index',
          trigger: 'section.pte',
          start: 'top',
          end: '1350%',
          pin: true,
          scrub: true,
          preventOverlaps: true,
          fastScrollEnd: true,
          toggleActions: 'restart none reverse none'
        }
      })

      const images = this.$gsap.utils.toArray('.rot-images')
      const descriptions = this.$gsap.utils.toArray('.desc')

      timeline
          // 0
          .call((index) => {
            this.bgImageIndex = index
          }, [0])
          .fromTo(images[0], {
            scale: 1,
            zIndex: 4
          }, {
            motionPath: {
              path: '#ptePath',
              align: '#ptePath',
              alignOrigin: [0.5, 0.5],
              autoRotate: false,
              start: 0,
              end: 0.25
            },
            zIndex: 1,
            scale: 0.5,
            duration: 3,
            ease: 'power1.inOut'
          })
          .fromTo(images[1], {
            scale: 0.5
          }, {
            motionPath: {
              path: '#ptePath',
              align: '#ptePath',
              alignOrigin: [0.5, 0.5],
              autoRotate: false,
              start: 0.25,
              end: 0.5
            },
            duration: 3,
            ease: 'power1.inOut'
          }, '-=3')
          .fromTo(images[2], {
            scale: 0.5
          }, {
            motionPath: {
              path: '#ptePath',
              align: '#ptePath',
              alignOrigin: [0.5, 0.5],
              autoRotate: false,
              start: 0.5,
              end: 0.75
            },
            duration: 3,
            ease: 'power1.inOut'
          }, '-=3')
          .fromTo(images[3], {
            scale: 0.5,
            zIndex: 3
          }, {
            motionPath: {
              path: '#ptePath',
              align: '#ptePath',
              alignOrigin: [0.5, 0.5],
              autoRotate: false,
              start: 0.75,
              end: 1
            },
            zIndex: 4,
            scale: 1,
            duration: 3,
            ease: 'power1.inOut'
          }, '-=3')
          .call((index) => {
            this.bgImageIndex = index
          }, [1], '-=1')
          .to(descriptions[0], {
            duration: 1,
            opacity: 0,
            y: '-=100%',
            delay: 1,
            ease: 'linear'
          }, '-=3')
          .fromTo(descriptions[1], {y: '+=100%'}, {
            duration: 1,
            delay: 1,
            y: 0,
            ease: 'linear'
          }, '-=3')
          // 1
          .fromTo(images[3], {zIndex: 4, scale: 1}, {
            motionPath: {
              path: '#ptePath',
              align: '#ptePath',
              alignOrigin: [0.5, 0.5],
              autoRotate: false,
              start: 0,
              end: 0.25
            },
            zIndex: 1,
            scale: 0.5,
            duration: 3,
            ease: 'power1.inOut'
          })
          .fromTo(images[0], {
            scale: 0.5
          }, {
            motionPath: {
              path: '#ptePath',
              align: '#ptePath',
              alignOrigin: [0.5, 0.5],
              autoRotate: false,
              start: 0.25,
              end: 0.5
            },
            duration: 3,
            ease: 'power1.inOut'
          }, '-=3')
          .fromTo(images[1], {
            scale: 0.5
          }, {
            motionPath: {
              path: '#ptePath',
              align: '#ptePath',
              alignOrigin: [0.5, 0.5],
              autoRotate: false,
              start: 0.5,
              end: 0.75
            },
            duration: 3,
            ease: 'power1.inOut'
          }, '-=3')
          .fromTo(images[2], {
            zIndex: 1,
            scale: 0.5
          }, {
            motionPath: {
              path: '#ptePath',
              align: '#ptePath',
              alignOrigin: [0.5, 0.5],
              autoRotate: false,
              start: 0.75,
              end: 1
            },
            zIndex: 4,
            scale: 1,
            duration: 3,
            ease: 'power1.inOut'
          }, '-=3')
          .call((index) => {
            this.bgImageIndex = index
          }, [2], '-=1')
          .to(descriptions[1], {
            duration: 1,
            opacity: 0,
            y: '-=100%'
          }, '-=3')
          .fromTo(descriptions[2], {y: '+=100%'}, {
            duration: 1,
            y: 0
          }, '-=3')
          //2
          .fromTo(images[2], {scale: 1}, {
            motionPath: {
              path: '#ptePath',
              align: '#ptePath',
              alignOrigin: [0.5, 0.5],
              autoRotate: false,
              start: 0,
              end: 0.25
            },
            scale: 0.5,
            duration: 3,
            ease: 'power1.inOut'
          })
          .fromTo(images[3], {
            scale: 0.5
          }, {
            motionPath: {
              path: '#ptePath',
              align: '#ptePath',
              alignOrigin: [0.5, 0.5],
              autoRotate: false,
              start: 0.25,
              end: 0.5
            },
            duration: 3,
            ease: 'power1.inOut'
          }, '-=3')
          .fromTo(images[0], {
            scale: 0.5
          }, {
            motionPath: {
              path: '#ptePath',
              align: '#ptePath',
              alignOrigin: [0.5, 0.5],
              autoRotate: false,
              start: 0.5,
              end: 0.75
            },
            duration: 3,
            ease: 'power1.inOut'
          }, '-=3')
          .fromTo(images[1], {
            zIndex: 1,
            scale: 0.5
          }, {
            motionPath: {
              path: '#ptePath',
              align: '#ptePath',
              alignOrigin: [0.5, 0.5],
              autoRotate: false,
              start: 0.75,
              end: 1
            },
            zIndex: 4,
            scale: 1,
            duration: 3,
            ease: 'power1.inOut'
          }, '-=3')
          .call((index) => {
            this.bgImageIndex = index
          }, [3], '-=1')
          .to(descriptions[2], {
            duration: 1,
            opacity: 0,
            y: '-=100%'
          }, '-=3')
          .fromTo(descriptions[3], {y: '+=100%'}, {
            duration: 1,
            y: 0
          }, '-=3')
      return timeline
    },
    initPathsM() {
      this.$motionPlugin.convertToPath('#ptePath')
      const timeline = this.$gsap.timeline({
        ease: Power1.easeInOut,
        scrollTrigger: {
          invalidateOnRefresh: true,
          scroller: '#index',
          trigger: 'section.pte',
          start: 'top',
          end: '300%',
          pin: true,
          scrub: true,
          preventOverlaps: true,
          fastScrollEnd: true,
          toggleActions: 'restart none reverse none'
        }
      })


      const images = this.$gsap.utils.toArray('.rot-images')
      const descriptions = this.$gsap.utils.toArray('.desc')

      timeline
          // 0
          .call((index) => {
            this.bgImageIndex = index
          }, [0])
          .fromTo(images[0], {
            scale: 1,
            zIndex: 4
          }, {
            motionPath: {
              path: '#ptePath',
              align: '#ptePath',
              alignOrigin: [0.5, 0.5],
              autoRotate: false,
              start: 0,
              end: 0.25
            },
            zIndex: 3,
            scale: 0.25,
            duration: 3,
            ease: 'power1.inOut'
          })
          .fromTo(images[1], {
            scale: 0.25
          }, {
            motionPath: {
              path: '#ptePath',
              align: '#ptePath',
              alignOrigin: [0.5, 0.5],
              autoRotate: false,
              start: 0.25,
              end: 0.5
            },
            duration: 3,
            ease: 'power1.inOut'
          }, '-=3')
          .fromTo(images[2], {
            scale: 0.25
          }, {
            motionPath: {
              path: '#ptePath',
              align: '#ptePath',
              alignOrigin: [0.5, 0.5],
              autoRotate: false,
              start: 0.5,
              end: 0.75
            },
            duration: 3,
            ease: 'power1.inOut'
          }, '-=3')
          .fromTo(images[3], {
            scale: 0.25,
            zIndex: 3
          }, {
            motionPath: {
              path: '#ptePath',
              align: '#ptePath',
              alignOrigin: [0.5, 0.5],
              autoRotate: false,
              start: 0.75,
              end: 1
            },
            zIndex: 4,
            scale: 1,
            duration: 3,
            ease: 'power1.inOut'
          }, '-=3')
          .call((index) => {
            this.bgImageIndex = index
          }, [1], '-=1')
          .to(descriptions[0], {
            duration: 1,
            opacity: 0,
            y: '-=100%',
            ease: 'linear'
          }, '-=3')
          .fromTo(descriptions[1], {y: '+=100%'}, {
            duration: 1,
            y: 0,
            ease: 'linear'
          }, '-=3')
          // 1
          .fromTo(images[3], {
            scale: 1,
            zIndex: 4
          }, {
            motionPath: {
              path: '#ptePath',
              align: '#ptePath',
              alignOrigin: [0.5, 0.5],
              autoRotate: false,
              start: 0,
              end: 0.25
            },
            zIndex: 3,
            scale: 0.25,
            duration: 3,
            ease: 'power1.inOut'
          })
          .fromTo(images[0], {
            scale: 0.25
          }, {
            motionPath: {
              path: '#ptePath',
              align: '#ptePath',
              alignOrigin: [0.5, 0.5],
              autoRotate: false,
              start: 0.25,
              end: 0.5
            },
            duration: 3,
            ease: 'power1.inOut'
          }, '-=3')
          .fromTo(images[1], {
            scale: 0.25
          }, {
            motionPath: {
              path: '#ptePath',
              align: '#ptePath',
              alignOrigin: [0.5, 0.5],
              autoRotate: false,
              start: 0.5,
              end: 0.75
            },
            duration: 3,
            ease: 'power1.inOut'
          }, '-=3')
          .fromTo(images[2], {
            scale: 0.25,
            zIndex: 3
          }, {
            motionPath: {
              path: '#ptePath',
              align: '#ptePath',
              alignOrigin: [0.5, 0.5],
              autoRotate: false,
              start: 0.75,
              end: 1
            },
            zIndex: 4,
            scale: 1,
            duration: 3,
            ease: 'power1.inOut'
          }, '-=3')
          .call((index) => {
            this.bgImageIndex = index
          }, [2], '-=1')
          .to(descriptions[1], {
            duration: 1,
            opacity: 0,
            y: '-=100%'
          }, '-=3')
          .fromTo(descriptions[2], {y: '+=100%'}, {
            duration: 1,
            y: 0
          }, '-=3')
          //2
          .fromTo(images[2], {scale: 1, zIndex: 4}, {
            motionPath: {
              path: '#ptePath',
              align: '#ptePath',
              alignOrigin: [0.5, 0.5],
              autoRotate: false,
              start: 0,
              end: 0.25
            },
            zIndex: 3,
            scale: 0.25,
            duration: 3,
            ease: 'power1.inOut'
          })
          .fromTo(images[3], {
            scale: 0.25
          }, {
            motionPath: {
              path: '#ptePath',
              align: '#ptePath',
              alignOrigin: [0.5, 0.5],
              autoRotate: false,
              start: 0.25,
              end: 0.5
            },
            duration: 3,
            ease: 'power1.inOut'
          }, '-=3')
          .fromTo(images[0], {
            scale: 0.25
          }, {
            motionPath: {
              path: '#ptePath',
              align: '#ptePath',
              alignOrigin: [0.5, 0.5],
              autoRotate: false,
              start: 0.5,
              end: 0.75
            },
            duration: 3,
            ease: 'power1.inOut'
          }, '-=3')
          .fromTo(images[1], {
            scale: 0.25,
            zIndex: 3
          }, {
            motionPath: {
              path: '#ptePath',
              align: '#ptePath',
              alignOrigin: [0.5, 0.5],
              autoRotate: false,
              start: 0.75,
              end: 1
            },
            zIndex: 4,
            scale: 1,
            duration: 3,
            ease: 'power1.inOut'
          }, '-=3')
          .call((index) => {
            this.bgImageIndex = index
          }, [3], '-=1')
          .to(descriptions[2], {
            duration: 1,
            opacity: 0,
            y: '-=100%'
          }, '-=3')
          .fromTo(descriptions[3], {y: '+=100%'}, {
            duration: 1,
            y: 0
          }, '-=3')
      // .to('.description', {
      //   duration: 6,
      //   yPercent: '-100%'
      // }, '-=6')

      return timeline
    },
    animations() {
      this.$scrollTrigger.saveStyles(
          '.rot-images-wrapper, .description, .rot-images, section.pte, .desc'
      )
      this.$scrollTrigger.matchMedia({
        '(min-width: 1025px)': () => {
          if (timeline) {
            timeline.kill()
            timeline = null
          }
          timeline = this.initPaths()

          return () => {
            if (timeline) {
              timeline.kill()
              timeline = null
            }
          }
        },
        '(max-width: 1024px)': () => {
          if (timeline) {
            timeline.kill()
            timeline = null
          }

          timeline = this.initPathsM()

          return () => {
            if (timeline) {
              timeline.kill()
              timeline = null
            }
          }
        }
      })

      // this.$scrollTrigger.refresh()
    }
  },
  mounted() {
  },
  beforeDestroy() {
    if (timeline) {
      timeline.kill()
    }
  }
}
</script>

<style scoped lang="scss">
section::v-deep {
  position: relative;
  width: 100%;
  max-height: 100vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;

  &::before {
    content: '';
    background-image: linear-gradient(180deg, #000000 1.72%, rgba(0, 0, 0, 0.54) 25.95%, rgba(0, 0, 0, 0.69) 50.04%, rgba(0, 0, 0, 0.54) 76.12%, #000000 98.36%), var(--bg-image);
    background-position: center;
    background-size: cover;
    width: 100%;
    height: 100%;
    max-height: 100vh;
    position: absolute;
    opacity: 0.3;
  }

  @media screen and (min-width: 1025px) {
    .world {
      width: 41.667vw;
      height: 24.740vw;
    }

    .rot-images-wrapper {
      position: relative;
      height: 100vh;
      transform: translateX(-25%);

      .rot-images {
        position: absolute;
        width: 80%;
      }
    }
    .ptePathWrapper {
      width: 85%;
      height: 85%;
    }
  }
  @media screen and (max-width: 1024px) {
    justify-content: center;
    .world {
      width: 80%;
    }


    .rot-images-wrapper {
      position: relative;
      width: 100%;
      transform: translateX(-25%);

      .rot-images {
        position: absolute;
        width: 85%;
      }

      &::before {
      }
    }

    .ptePathWrapper {
      width: 40%;
      height: 40%;
    }

    .description {
      height: auto;
    }
  }
}

</style>
